import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProject, fetchProductCategories, addProjectProductCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProjectProductCategoryAddPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const [available, setAvailable] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [project, all] = await Promise.all([
          fetchProject(projectId),
          fetchProductCategories(businessUnitId),
        ]);
        const assigned = new Set((project.associatedProductCategories || []).map((c) => c.productCategoryId));
        setAvailable((Array.isArray(all) ? all : []).filter((c) => !assigned.has(c.productCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, businessUnitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) { notify.error(t("common.selectRequired")); return; }
    try {
      await addProjectProductCategory(projectId, selectedId);
      notify.success(t("message.create.success"));
      navigate(`${basePath}/product-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("project.productCategory.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("productCategory.name")}</InputLabel>
              <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}
                label={t("productCategory.name")}>
                {available.map((c) => (
                  <MenuItem key={c.productCategoryId} value={c.productCategoryId}>
                    {c.productCategoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
